define(
    'helper',['loader'],
    function(Loader)
    {
        var $ = Loader.$;
        var _ = Loader._;
        var Backbone = Loader.Backbone;

        var _calculateUserDateTime = function(jsTimestamp, format) {
            var dateString = new Date(jsTimestamp);

            var replacements = new Object({
                d: dateString.getDate(),
                m: dateString.getMonth() + 1, // Because 0 - January and 11 - December
                M: _getMonthName(dateString.getMonth() + 1), // Because 0 - January and 11 - December
                y: dateString.getFullYear() - 2000,
                Y: dateString.getFullYear(),
                H: dateString.getHours(),
                i: dateString.getMinutes(),
                s: dateString.getSeconds()
            });

            for (key in replacements) {
                if(parseInt(replacements[key]) < 10) {
                    replacements[key] = '0' + replacements[key];
                }
                format = format.replace(key, replacements[key]);
            }

            return format;
        };

        var _getMonthName = function(index) {
            index--;
            var months =
                [
                    'января',
                    'февраля',
                    'марта',
                    'апреля',
                    'мая',
                    'июня',
                    'июля',
                    'августа',
                    'сентября',
                    'октября',
                    'ноября',
                    'декабря'
                ];
            return months[index];
        };

        var _cancelTouchStart = function(event) {
            event.preventDefault();
        };

        var _prepareEventsForDevice = function(events, eventType) {
            if(eventType == 'click') return events;
            var newEvents = {};
            for(i in events) {
                var index = i;
                newEvents[i.replace(/click/, eventType)] = events[i];
                newEvents[index.replace(/click/, 'touchstart')] = _cancelTouchStart;
            }
            return newEvents;
        };

        var _checkRangeValue = function(n1, n2, limit) {

            if( typeof limit == 'undefined' ) limit = 5;

            return (n1-limit < n2 && n2 < n1+limit);
        };

        var _cloneArray = function(array) {
            return array.slice(0);
        };

        var _formatNumber = function(nStr)
        {
            nStr += '';
            var x = nStr.split('.');
            var x1 = x[0];
            var x2 = x.length > 1 ? '.' + x[1] : '';
            var rgx = /(\d+)(\d{3})/;
            while (rgx.test(x1))
            {
                x1 = x1.replace(rgx, '$1' + ' ' + '$2');
            }
            return x1 + x2;
        };

        var _sprintf = function() {	// Return a formatted string
            //
            // +   original by: Ash Searle (http://hexmen.com/blog/)
            // + namespaced by: Michael White (http://crestidg.com)

            var regex = /%%|%(\d+\$)?([-+#0 ]*)(\*\d+\$|\*|\d+)?(\.(\*\d+\$|\*|\d+))?([scboxXuidfegEG])/g;
            var a = arguments, i = 0, format = a[i++];
            format = format ? format : '';

            // pad()
            var pad = function(str, len, chr, leftJustify) {
                var padding = (str.length >= len) ? '' : Array(1 + len - str.length >>> 0).join(chr);
                return leftJustify ? str + padding : padding + str;
            };

            // justify()
            var justify = function(value, prefix, leftJustify, minWidth, zeroPad) {
                var diff = minWidth - value.length;
                if (diff > 0) {
                    if (leftJustify || !zeroPad) {
                        value = pad(value, minWidth, ' ', leftJustify);
                    } else {
                        value = value.slice(0, prefix.length) + pad('', diff, '0', true) + value.slice(prefix.length);
                    }
                }
                return value;
            };

            // formatBaseX()
            var formatBaseX = function(value, base, prefix, leftJustify, minWidth, precision, zeroPad) {
                // Note: casts negative numbers to positive ones
                var number = value >>> 0;
                prefix = prefix && number && {'2': '0b', '8': '0', '16': '0x'}[base] || '';
                value = prefix + pad(number.toString(base), precision || 0, '0', false);
                return justify(value, prefix, leftJustify, minWidth, zeroPad);
            };

            // formatString()
            var formatString = function(value, leftJustify, minWidth, precision, zeroPad) {
                if (precision != null) {
                    value = value.slice(0, precision);
                }
                return justify(value, '', leftJustify, minWidth, zeroPad);
            };

            // finalFormat()
            var doFormat = function(substring, valueIndex, flags, minWidth, _, precision, type) {
                if (substring == '%%') return '%';

                // parse flags
                var leftJustify = false, positivePrefix = '', zeroPad = false, prefixBaseX = false;
                for (var j = 0; flags && j < flags.length; j++) switch (flags.charAt(j)) {
                    case ' ': positivePrefix = ' '; break;
                    case '+': positivePrefix = '+'; break;
                    case '-': leftJustify = true; break;
                    case '0': zeroPad = true; break;
                    case '#': prefixBaseX = true; break;
                }

                // parameters may be null, undefined, empty-string or real valued
                // we want to ignore null, undefined and empty-string values
                if (!minWidth) {
                    minWidth = 0;
                } else if (minWidth == '*') {
                    minWidth = +a[i++];
                } else if (minWidth.charAt(0) == '*') {
                    minWidth = +a[minWidth.slice(1, -1)];
                } else {
                    minWidth = +minWidth;
                }

                // Note: undocumented perl feature:
                if (minWidth < 0) {
                    minWidth = -minWidth;
                    leftJustify = true;
                }

                if (!isFinite(minWidth)) {
                    throw new Error('sprintf: (minimum-)width must be finite');
                }

                if (!precision) {
                    precision = 'fFeE'.indexOf(type) > -1 ? 6 : (type == 'd') ? 0 : void(0);
                } else if (precision == '*') {
                    precision = +a[i++];
                } else if (precision.charAt(0) == '*') {
                    precision = +a[precision.slice(1, -1)];
                } else {
                    precision = +precision;
                }

                // grab value using valueIndex if required?
                var value = valueIndex ? a[valueIndex.slice(0, -1)] : a[i++];

                switch (type) {
                    case 's': return formatString(String(value), leftJustify, minWidth, precision, zeroPad);
                    case 'c': return formatString(String.fromCharCode(+value), leftJustify, minWidth, precision, zeroPad);
                    case 'b': return formatBaseX(value, 2, prefixBaseX, leftJustify, minWidth, precision, zeroPad);
                    case 'o': return formatBaseX(value, 8, prefixBaseX, leftJustify, minWidth, precision, zeroPad);
                    case 'x': return formatBaseX(value, 16, prefixBaseX, leftJustify, minWidth, precision, zeroPad);
                    case 'X': return formatBaseX(value, 16, prefixBaseX, leftJustify, minWidth, precision, zeroPad).toUpperCase();
                    case 'u': return formatBaseX(value, 10, prefixBaseX, leftJustify, minWidth, precision, zeroPad);
                    case 'i':
                    case 'd': {
                        var number = parseInt(+value);
                        var prefix = number < 0 ? '-' : positivePrefix;
                        value = prefix + pad(String(Math.abs(number)), precision, '0', false);
                        return justify(value, prefix, leftJustify, minWidth, zeroPad);
                    }
                    case 'e':
                    case 'E':
                    case 'f':
                    case 'F':
                    case 'g':
                    case 'G':
                    {
                        var number = +value;
                        var prefix = number < 0 ? '-' : positivePrefix;
                        var method = ['toExponential', 'toFixed', 'toPrecision']['efg'.indexOf(type.toLowerCase())];
                        var textTransform = ['toString', 'toUpperCase']['eEfFgG'.indexOf(type) % 2];
                        value = prefix + Math.abs(number)[method](precision);
                        return justify(value, prefix, leftJustify, minWidth, zeroPad)[textTransform]();
                    }
                    default: return substring;
                }
            };

            return format.replace(regex, doFormat);
        };

        var _currentTimestamp = function() {
            return Math.floor(new Date() / 1000);
        };

        var _rand = function( min, max ) {
            if( max ) {
                return Math.floor(Math.random() * (max - min + 1)) + min;
            } else {
                return Math.floor(Math.random() * (min + 1));
            }
        };

        var _filterRoutes = function(routes, context) {
            var list = [];

            _.each(routes, function(functions, pattern){
                if (pattern == "*" || new RegExp(pattern).test(document.location.href)) {
                    _.each(functions.split(" "), function(func){
                        if (_.indexOf(list, func) == -1) {
                            list.push(func);
                        }
                    });
                }
            });

            _.each(list, function(func){
                context[func]();
            });

            return context;

        };

        var _isValidRoute = function(pattern) {
            if (pattern == "*" || new RegExp(pattern).test(document.location.href)) {
                return true;
            }
            return false;
        };

        var _htmlspecialchars = function(html) { 
            // Сначала необходимо заменить &
            html = html.replace(/&/g, "&amp;");
            // А затем всё остальное в любой последовательности
            html = html.replace(/</g, "&lt;");
            html = html.replace(/>/g, "&gt;");
            html = html.replace(/"/g, "&quot;");
            // Возвращаем полученное значение
            return html;
        };

        var _getParam = function(sParamName){
            var Params = location.search.substring(1).split("&");
            variable = ""; for (var i = 0; i < Params.length; i++){
                if (Params[i].split("=")[0] == sParamName){
                    if (Params[i].split("=").length > 1)
                        variable = Params[i].split("=")[1];
                    return variable;
                }
            }
            return "";
        };

        var _nl2br = function(string){
            return string.replace(/\n/g, "<br />");
        };

        var _declOfNum = function(number, titles)
        {
            var cases = [2, 0, 1, 1, 1, 2];
            return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
        };

        var _safeQuotes = function(str)
        {
            return str.replace(/"/g, "&quot;");
        };

        return {
            calculateUserDateTime: _calculateUserDateTime,
            prepareEventsForDevice: _prepareEventsForDevice,
            checkRangeValue: _checkRangeValue,
            cloneArray: _cloneArray,
            formatNumber: _formatNumber,
            sprintf: _sprintf,
            currentTimestamp: _currentTimestamp,
            rand: _rand,
            htmlspecialchars: _htmlspecialchars,
            filterRoutes: _filterRoutes,
            getParam: _getParam,
            nl2br: _nl2br,
            isValidRoute: _isValidRoute,
            declOfNum: _declOfNum,
            safeQuotes: _safeQuotes
        };
    }
);

